export const LOADER = {
    INCREASE: "LOADER.INCREASE",
    DEGREASE: "LOADER.DEGREASE",
    RESET: "LOADER.RESET",
};